import { render } from "./Product.vue?vue&type=template&id=0d7238e0&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=0d7238e0&lang=css"
import "./Product.vue?vue&type=style&index=1&id=0d7238e0&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7238e0"]])

export default __exports__